// Map service region names to IANA timezone identifiers
const regionToTimezone: Record<string, string> = {
    'West Region - Nor.Cal': 'America/Los_Angeles',
    'West Region - So.Cal': 'America/Los_Angeles',
    'West Region - Const Serv': 'America/Los_Angeles',
    'East Region': 'America/New_York',
    'Midwest Region': 'America/Chicago',
    'NY NJ Region': 'America/New_York'
};

/**
 * Formats a UTC timestamp to a localized date/time string.
 * If a valid region name is provided, converts to the facility's timezone and includes timezone abbreviation.
 * Otherwise, displays in user's local time without timezone indicator.
 *
 * @param dateString - ISO date string (UTC with Z suffix)
 * @param regionName - Service region name from ZipMaster.SrvRegionName
 * @returns Formatted date/time string
 */
export const formatTimestampWithTimezone = (
    dateString?: string | null,
    regionName?: string | null
): string => {
    const date = dateString ? new Date(dateString) : new Date();
    const timezone = regionName ? regionToTimezone[regionName] : null;

    if (timezone) {
        try {
            // Format in facility's timezone and include timezone abbreviation
            return date.toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
                timeZone: timezone,
                timeZoneName: 'short'
            });
        } catch {
            // Fall through to local time if timezone conversion fails
        }
    }

    // No region timezone or conversion failed - use user's local time without timezone indicator
    return date.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
};

/**
 * Gets the IANA timezone identifier for a given service region name.
 *
 * @param regionName - Service region name from ZipMaster.SrvRegionName
 * @returns IANA timezone identifier or null if not found
 */
export const getTimezoneForRegion = (
    regionName?: string | null
): string | null => {
    if (!regionName) return null;
    return regionToTimezone[regionName] || null;
};
